import { useContext } from 'react'
import analyticsContext from './analyticsContext'

const useAnalytics = () => {
    return useContext(analyticsContext)
}

export default useAnalytics
